/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by richardwilliams on 4/15/15.
 */

function PackageMediaImageAssetSelectorController (
    this: JS5Object,
    _: JS5Object,
    AssetValidationService: JS5Object,
    DynamicPropertiesService: JS5Object,
    PackageFileUploadService: JS5Object,
    PackageMediaService: JS5Object,
    PackageUtilService: JS5Object,
    TempFileUploadService: JS5Object,
) {

    const setImage = (virtualPath: string, isRemoteUploadEnabled: boolean) => {
        this.imageAsset.virtualPath = virtualPath;
        this.imageAsset.assetId = -1;
        if (isRemoteUploadEnabled) {
            this.imageAsset.pendingIngest = true;
        } else {
            delete this.imageAsset.pendingIngest;
        }
        PackageUtilService.editorForm.$setDirty();
    };


    //================//
    // Template Logic //
    //================//

    this.remoteUploadEnabled = () => {
        return DynamicPropertiesService.getPropValueAsBoolean('mediaTabRemoteUpload.enabled', false);
    }

    this.getSelectedAcceptTemplateMember = () => {
        return PackageMediaService.packageMediaData.selectedImageAcceptTemplateMember;
    };

    this.onViewAssetButtonClick = ($event: JS5Object) => {
        $event.stopImmediatePropagation();
        PackageMediaService.openViewAssetModal(this.imageAsset);
    };

    this.onQualityControlButtonClick = ($event: JS5Object) => {
        $event.stopImmediatePropagation();
        PackageMediaService.openQualityControlModal(this.imageAsset);
    };

    this.onCurrentFileChanged = () => {
        PackageFileUploadService.unregisterLocalConfig(this.uploaderConfig);
        setImage(null, false);
        if (_.get(this, 'currentFile.status') === 'PASSED') {
            switch (this.currentFile.type) {
                case 'ASPERA':
                    // TODO: Test in UI when Aspera is configured
                    setImage(this.currentFile.results[0].uploadedData, true);
                    break;
                case 'LOCAL':
                    // Display fileName (Correct virtualPath is set when media is saved)
                    PackageFileUploadService.registerLocalConfigForUpload(this.uploaderConfig);
                    setImage(`s3:fakePath/${this.currentFile.files[0].file.name}`, false);
                    break;
                case 'REMOTE':
                    setImage(this.currentFile.files[0].virtualPath, false);
                    break;
            }
        }
    };


    //========================//
    // Remote File Validation //
    //========================//

    const getAcceptProfile = () => {
        return this.getSelectedAcceptTemplateMember().acceptProfile;
    };

    this.validateRemoteFile = (fileSystemItem: JS5Object) => {
        let virtualPath = fileSystemItem.parent + fileSystemItem.name;
        return AssetValidationService.validateMediaRemote(virtualPath, getAcceptProfile().id);
    };


    //========================//
    // Aspera File Validation //
    //========================//

    this.validateAsperaFile = (asperaFileObject: JS5Object) => {
        return AssetValidationService.validateMediaLocal(asperaFileObject.file, getAcceptProfile())
            .then((result: JS5Object) => {
                return PackageFileUploadService.parseAsperaValidationResult(PackageMediaService.packageObject, asperaFileObject, result);
            });
    };


    //=======================//
    // Local File Validation //
    //=======================//

    this.getLocalFilePreValidationErrors = (file: File, filter: JS5Object) => {
        // Doesn't add any local file filters
    };

    this.validateLocalFile = (fileItem: JS5Object, uploaderConfig: JS5Object) => {
        fileItem.onVirtualPathSet = (virtualPath: string) => {
            setImage(virtualPath, true);
        };
        return AssetValidationService.validateMediaLocal(fileItem._file, getAcceptProfile());
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.languages = PackageMediaService.packageMediaData.languages;
    };

    this.initializeLocalUploaderConfig = (uploaderConfig: JS5Object) => {
        TempFileUploadService.initialize(uploaderConfig);
        this.uploaderConfig = uploaderConfig;
    };

    this.$onChanges = (changes: JS5Object) => {
        if (changes.imageAsset && this.uploaderConfig) {
            this.currentFile = null;
        }
    };

    this.$onDestroy = () => {
        PackageFileUploadService.unregisterLocalConfig(this.uploaderConfig);
    };
}

angular.module('prism-ui.package').component('packageMediaImageAssetSelector', {
    controller: PackageMediaImageAssetSelectorController,
    templateUrl: 'package/editor/components/view/media/assetSelector/image/package-media-image-asset-selector-template.html',
    bindings: {
        imageAsset: '<',
        listIndex: '<'
    }
});
